import React from 'react';
import { Body5, Container } from '@ui';
import { isAgentOutputValid, formatAgentOutput } from '@utils/agents';
import { PrettyJSON } from '@ui/text/PrettyJSON';

export const AgentStepOutput = ({ output }) => {
  if (!output) return null;
  if (!isAgentOutputValid(output)) {
    return <Body5>{output}</Body5>;
  }

  const formattedOutput = formatAgentOutput(output);
  if (!formattedOutput || !formattedOutput.answer) {
    return <Body5>{formattedOutput}</Body5>;
  }

  return (
    <Container>
      {formattedOutput.answer.map((item, index) => (
        <Container key={index}>
          <Body5>{item.question}</Body5>
          <Container top={8}>
            <PrettyJSON value={item.response} />
          </Container>
        </Container>
      ))}
    </Container>
  );
};
